import React from "react"
import Box from "@mui/material/Box"
import { MONO, CHAT_COLOR, AGENT_COLORS, MARKUP_RE } from "../constants"
import { VaultLinkChip } from "../components/VaultLinkChip"

export function getMentionAt(text, cursorPos) {
  const before = text.slice(0, cursorPos)
  const match = before.match(/@(\w*)$/)
  if (!match) return null
  return { query: match[1], start: cursorPos - match[0].length }
}

export function renderText(text, onVaultLink, knownUsers) {
  const parts = []
  let last = 0
  let m
  MARKUP_RE.lastIndex = 0
  while ((m = MARKUP_RE.exec(text)) !== null) {
    if (m.index > last) parts.push(<span key={"t" + last}>{text.slice(last, m.index)}</span>)
    if (m[1] !== undefined) {
      const path = m[1]
      const label = path.split("/").pop().replace(/\.md$/, "")
      parts.push(
        <VaultLinkChip key={"l" + m.index} path={path} label={label} onVaultLink={onVaultLink} />
      )
    } else {
      const key = m[2].toLowerCase()
      const agentColor = AGENT_COLORS[key]
      const isKnown = agentColor || knownUsers?.has(key)
      parts.push(
        <Box key={"a" + m.index} component="span"
          sx={{ color: agentColor ?? (isKnown ? "var(--app-success)" : "rgba(var(--app-fg-rgb),0.55)"), fontWeight: isKnown ? 700 : 400 }}>
          @{m[2]}
        </Box>
      )
    }
    last = m.index + m[0].length
  }
  if (last < text.length) parts.push(<span key={"t" + last}>{text.slice(last)}</span>)
  return parts.length ? parts : text
}

export function renderWithCode(text, onVaultLink, knownUsers) {
  const parts = text.split(/(```[\s\S]*?```|`[^`]+`)/g)
  return parts.map((part, i) => {
    if (part.startsWith("```") && part.endsWith("```")) {
      const code = part.slice(3, -3).replace(/^\w+\n/, "")
      return (
        <Box key={i} component="pre" sx={{
          backgroundColor: "var(--app-paper)",
          border: "1px solid rgba(var(--app-fg-rgb),0.1)",
          borderLeft: "3px solid var(--app-warning)",
          borderRadius: "4px",
          p: 1.5,
          my: 0.5,
          overflowX: "auto",
          fontFamily: MONO,
          fontSize: "0.78em",
          lineHeight: 1.6,
          color: "var(--app-text)",
          whiteSpace: "pre",
        }}>{code}</Box>
      )
    } else if (part.startsWith("`") && part.endsWith("`")) {
      return (
        <Box key={i} component="code" sx={{
          backgroundColor: "#1a1a2e", color: CHAT_COLOR,
          px: 0.5, py: 0.1, borderRadius: "3px",
          fontFamily: MONO, fontSize: "0.85em",
        }}>{part.slice(1, -1)}</Box>
      )
    }
    return <React.Fragment key={i}>{renderText(part, onVaultLink, knownUsers)}</React.Fragment>
  })
}
